module.exports = __webpack_public_path__ + "img/ic-account-white.741a99d7.svg";